// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LoadingDotOutlinedSvg from "@fishx/icons-svg/es/asn/LoadingDotOutlined";
import FishxIcon from '../components/FishxIcon';

var LoadingDotOutlined = function LoadingDotOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LoadingDotOutlinedSvg
  }));
};

LoadingDotOutlined.displayName = 'LoadingDotOutlined';
export default React.forwardRef(LoadingDotOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LoadingDotOutlined.js
// module id = 3055
// module chunks = 0